// extracted by mini-css-extract-plugin
export default {"blogCard":"style_blogCard__O7d8w","blogImage":"style_blogImage__NDz7U","blogContent":"style_blogContent__TKBqq"};